@if (!!url) {
  <app-elearnio-mat-table-link
    [text]="text"
    [url]="url"
    [state]="state"
  ></app-elearnio-mat-table-link>
} @else {
  <span
    class="without-link"
    [class.archived]="
      state === TrainingAvailability.ARCHIVED ||
      state === TrainingAvailability.DRAFT
    "
  >
    @if (state === TrainingAvailability.ARCHIVED) {
      <mat-icon class="size-sm" fontSet="material-icons-outlined"
        >inventory_2</mat-icon
      >
    }
    @if (state === TrainingAvailability.DRAFT) {
      <mat-icon class="size-sm" fontSet="material-icons-outlined"
        >note_alt</mat-icon
      >
    }
    <span>{{ text }}</span>
  </span>
}
